import { defineNamespace, ConsumerTypes, ApiVersions } from '../../common';
import { platformAPICreator as platformAPICreatorV1Internal, } from './accessibility.internal.v1';
import { platformAPICreator as platformAPICreatorV2Internal, } from './accessibility.internal.v2';
export * from './accessibility.super';
export const namespaceCreator = defineNamespace((config) => {
    if (config.consumerType === ConsumerTypes.Internal &&
        config.version === ApiVersions.V1) {
        return platformAPICreatorV1Internal(config.superAPI)(config.context);
    }
    if (config.consumerType === ConsumerTypes.Internal &&
        config.version === ApiVersions.V2) {
        return platformAPICreatorV2Internal(config.superAPI)(config.context);
    }
    return null;
});
//# sourceMappingURL=index.js.map